// extracted by mini-css-extract-plugin
module.exports = {"container":"_14a2675VPYv1KVHVB8xMyz","cancelBtn":"_24RB30l1it6ZEq1vHfAGkH","icon":"enQAkUwbSVeIfzx-ixEVg","saveBtn":"_2tUExUkVC5HjNkJasu8-qy"};